__turbopack_context__.v({
  "footerAnchor": "SimpleFooter-module__UDADhW__footerAnchor",
  "footerContainer": "SimpleFooter-module__UDADhW__footerContainer",
});
